import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { navItems } from './Linklist';
import { extItems } from './Extlist';
import './css.css';

const MainLink = () => {
  const location = useLocation();

  // navItems 배열에서 0번 항목을 제외합니다.
  const filteredNavItems = navItems.slice(1);

  // 7일 이내 업데이트 확인 함수
  const isRecentlyUpdated = (lastUpdated) => {
    if (!lastUpdated) return false;
    const updatedDate = new Date(lastUpdated);
    const today = new Date();
    const diffTime = Math.abs(today - updatedDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays <= 7;
  };

  return (
    <>
      <div className="page-content">
        {/* 내부링크 */}
        <div className="main-section">
          <h2 className="section-title">데이터 페이지</h2>
          <div className="main-grid internal">
            {filteredNavItems.map(({ pagePath, label, icon, isUpdated, lastUpdated }, index) => {
              const isActive = location.pathname === pagePath;
              const showUpdateBadge = isUpdated && isRecentlyUpdated(lastUpdated);
              
              return (
                <div className={`main-card internal ${isActive ? 'active' : ''}`} key={index}>
                  <Link to={pagePath} className="main-card-link">
                    <div className="main-card-icon">
                      <div className="icon-wrapper">
                        <img src={icon} alt={`${label.toLowerCase()} icon`} />
                        {showUpdateBadge && (
                          <span className="update-badge">업데이트</span>
                        )}
                      </div>
                    </div>
                    <div className="main-card-content">
                      <h3 className="main-card-title">{label}</h3>
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
        {/* 외부링크 */}
        <div className="main-section">
          <h2 className="section-title">외부 링크</h2>
          <div className="main-grid external">
            {extItems.map(({ pagePath, label, icon, inner }, index) => {
              return (
                <div className="main-card external" key={index}>
                  {inner ? (
                    <Link to={pagePath} className="main-card-link">
                      <div className="main-card-icon">
                        <img src={icon} alt={`${label.toLowerCase()} icon`} />
                      </div>
                      <div className="main-card-content">
                        <h3 className="main-card-title">{label}</h3>
                      </div>
                    </Link>
                  ) : (
                    <a href={pagePath} className="main-card-link" target="_blank" rel="noopener noreferrer">
                      <div className="main-card-icon">
                        <img src={icon} alt={`${label.toLowerCase()} icon`} />
                      </div>
                      <div className="main-card-content">
                        <h3 className="main-card-title">{label}</h3>
                      </div>
                    </a>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default MainLink;